const updates = [
  {
    date: '2026.07.30',
    title: '暑期档专题「盛夏光影」上线',
    desc: '精选50部高分夏日题材电影，涵盖青春、冒险、喜剧等多种类型，牛牛极清画质全程流畅播放。',
  },
  {
    date: '2026.07.28',
    title: '播放引擎升级至v3.8版本',
    desc: '牛牛不缓冲技术全面优化，4K片源加载速度提升40%，低带宽环境下依然保持超清流畅体验。',
  },
  {
    date: '2026.07.25',
    title: '热播剧《长安秘闻录》全集上线',
    desc: '豆瓣8.7分古装悬疑大剧，36集全集中文超清版本已就位，支持手机与电脑同步追剧。',
  },
  {
    date: '2026.07.22',
    title: '移动端观影界面全新改版',
    desc: '牛牛影视移动版UI重设计，更简洁的导航、更快的加载、更沉浸的全屏观影体验。',
  },
  {
    date: '2026.07.19',
    title: '片库突破12万部里程碑',
    desc: '涵盖电影、电视剧、纪录片、动漫等全品类内容，每日新增超过200部优质资源。',
  },
  {
    date: '2026.07.15',
    title: '智能推荐算法正式上线',
    desc: '基于观影偏好的AI推荐系统，精准匹配你可能喜欢的影视内容，发现更多冷门佳作。',
  },
  {
    date: '2026.07.10',
    title: '海外华语频道资源接入',
    desc: '新增港台及东南亚华语影视专区，包含大量未引进的优质剧集与综艺节目资源。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14 max-w-xl mx-auto">
          牛牛影视持续进化，每一次更新都为你带来更好的观影体验
        </p>
        <div className="relative">
          <div className="absolute left-3 md:left-4 top-2 bottom-2 w-px bg-background-300"></div>
          <div className="space-y-6 md:space-y-8">
            {updates.map((item, idx) => (
              <div key={idx} className="relative pl-10 md:pl-12">
                <div className="absolute left-0 top-1.5 w-6 h-6 md:w-8 md:h-8 rounded-full bg-primary-500 flex items-center justify-center">
                  <div className="w-2 h-2 md:w-2.5 md:h-2.5 rounded-full bg-background-50"></div>
                </div>
                <span className="text-xs md:text-sm text-foreground-400 font-medium">{item.date}</span>
                <h3 className="text-sm md:text-base font-heading text-foreground-900 mt-1 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}